// extracted by mini-css-extract-plugin
module.exports =  {"dialog":"NotSavedDialog-NotSavedDialog-dialog-afd7e88a"};